import { useState } from 'react';

function NewImageGallery({img}) {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [images, setImages] = useState(img)

  // Handle image click to open preview
  const handleImageClick = (index) => {
    setSelectedIndex(index);
  };

  // Close the preview modal
  const closePreview = () => {
    setSelectedIndex(null);
  };

  // Navigate to the next image
  const nextImage = () => {
    console.log('vame')
    setSelectedIndex((prevIndex) => (prevIndex + 1) % images.length);
    console.log(selectedIndex)
  };

  // Navigate to the previous image
  const prevImage = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="max-w-7xl mx-auto p-4">
      {/* Image Gallery */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-2">
        {img.map((image, index) => (
          <div key={index} className="relative group">
            <img
              src={image.ImageURL}
              alt={`Image ${index + 1}`}
              className="w-full h-full max-h-[220px] object-cover cursor-pointer"
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      {/* Image Preview Modal */}
      {selectedIndex !== null && (
        <div
          className="fixed inset-0 bg-black flex items-center justify-center z-50"
          onClick={closePreview}
        >
          <div className="relative w-full h-full " onClick={(e) => e.stopPropagation()} >
            <img
              src={images[selectedIndex].ImageURL}
              alt="Preview"
              className="w-full h-[90vh] object-contain mt-[5vh]"
            />
            {/* Close button */}
            <button
              className="absolute top-2 right-2 text-white bg-black bg-opacity-70 w-[40px] h-[40px] rounded-full"
              onClick={()=>closePreview()}
            >
              X
            </button>
            {/* Navigation buttons */}
            <div className="absolute inset-y-1/2 left-2 right-2 flex justify-between">
              <button
                className="bg-black bg-opacity-90 w-[50px] h-[50px] rounded-full text-white text-2xl"
                onClick={()=>prevImage()}
              >
                &lt;
              </button>
              <button
                className="bg-black bg-opacity-90 w-[50px] h-[50px] rounded-full text-white text-2xl"
                onClick={()=>nextImage()}
              >
                &gt;
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewImageGallery;
